export const updateClaimInfo = (state, payload) => {
  return {
    ...state,
    registration: {
      claimInfo: {
        ...state.registration.claimInfo,
        ...payload,
      },
    },
  };
};

export const updateAccountInfo = (state, payload) => {
  return {
    ...state,
    registration: {
      accountInfo: {
        ...state.registration.accountInfo,
        ...payload,
      },
    },
  };
};

export const updateCompanyName = (state, payload) => {
  return {
    ...state,
    registration: {
      ...state.registration.companyName,
      ...payload,
    },
  };
};

export const setPortalAccess = (state, payload) => {
  return {
    ...state,
    registration: {
      portalAccess: {
        ...state.registration.portalAccess,
        ...payload,
      },
    },
  };
};

export const setApimData = (state, payload) => {
  return {
    ...state,
    registration: {
      apim: {
        ...state.registration.apim,
        ...payload,
      },
    },
  };
};

export const resetForm = () => {
  return {
    registration: {
      claimInfo: {},
      accountInfo: {},
      companyName: '',
      portalAccess: {},
      apim: {},
    },
  };
};
